"use client";
import { Link } from "@/i18n/routing";
import { useEffect, useState } from "react";
// function isWebView() {
//     const userAgent = window.navigator && navigator.userAgent;

//     return /WebView|iPhone|iPod|Android/.test(userAgent);
// }
function isWebView() {
    const ua = navigator.userAgent.toLowerCase();
    return (
        (ua.indexOf("wv") > -1 || (ua.indexOf("android") > -1 && ua.indexOf("mobile") > -1)) &&
        ua.indexOf("like mac os x") === -1
    );
}

const DownloadSection = () => {
    const [visible, setVisible] = useState<boolean>(false);

    useEffect(() => {
        const isCloseDownload = sessionStorage.getItem("isCloseDownload");
        if (window?.isAndroidAPK || isCloseDownload) {
            setVisible(true);
        }
    }, []);

    const closeDownloadSection = () => {
        sessionStorage.setItem("isCloseDownload", "true");
        setVisible(true);
    };

    if (visible) return null;
    return (
        <div
            className={"relative flex items-center px-[0.1389rem] py-[0.0694rem]"}
            style={{
                background: "#2b363f", //"linear-gradient(169deg,#4d820b,rgba(0,75,61))",
            }}
        >
            <img className="w-[.34rem]" src="/home/downloadicon.webp" alt="" />
            {/* <div
                className={
                    "absolute -left-[0px] -top-[0px] h-[0.22rem] w-[0.24rem] text-[0.1rem]" +
                    " rounded-br-[0.3472rem] indent-[0.05rem] leading-[0.17rem]" +
                    " bg-[#181e21] text-[#fff]"
                }
                onClick={closeDownloadSection}
            >
                <i className={"iconfont icon-guanbi text-[0.1rem]"}></i>
            </div> */}
            <div className={"ml-[0.1389rem] flex-1"}>
                <p className={"text-[#fff]"}>
                    Baixe e ganhe{" "}
                    <img className="inline-block h-[.2rem]" src="/home/10.png" alt="" /> grátis
                </p>
                {/* <p className={"text-[0.1rem] text-[#75f537]"}>R$ 10</p> */}
            </div>
            <Link
                href={"/download"}
                className={
                    "flex h-[0.3rem] rounded-[0.04rem] bg-[#ebc71f] px-[0.12rem] " +
                    " items-center justify-center text-[0.12rem] text-[#000]"
                }
            >
                <i className={"iconfont icon-android text-[0.2rem]"}></i>
                <p className={"font-bold"}>BAIXE</p>
            </Link>
        </div>
    );
};

export default DownloadSection;
